import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Auth from '@Services/Auth';
import Breadcrumb from '@Services/Breadcrumb';
import { dispatchOpenUnavailableResultsDialog } from '@Containers/ResultSetValidation';

const withActiveBreadcrumb =
  ({ isHeatmap } = {}) =>
  (Component) => {
    function WithActiveBreadcrumbHOC(props) {
      const { params, location, history } = props;
      const { databaseId, resultName } = params;
      const activeBreadcrumb = useMemo(
        () =>
          isHeatmap || params.isHeatmap || location.pathname.includes('heatmap')
            ? Breadcrumb.getActiveBreadcrumbForDb(databaseId)
            : Breadcrumb.getBreadcrumbForDbByResultName(databaseId, resultName),
        [databaseId, resultName]
      );

      if (!activeBreadcrumb) {
        if (history.location.pathname.includes('results') || history.location.pathname.includes('heatmap')) {
          dispatchOpenUnavailableResultsDialog();
        }
        Auth.goToLandingPage(true);
        return null;
      }

      return <Component {...props} activeBreadcrumb={activeBreadcrumb} />;
    }

    WithActiveBreadcrumbHOC.propTypes = {
      params: PropTypes.object.isRequired,
    };

    return WithActiveBreadcrumbHOC;
  };

export default withActiveBreadcrumb;
